import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { deleteProjectClass, editProject, editProjectClass, getProject } from "../../services/projectService";
import { t } from "i18next";
import { useParams } from "react-router-dom";
import { EditIcon, DeleteIcon, CheckIcon, MoreVertIcon } from "../../icons";
import { toast, ToastContainer } from "react-toastify";
import { useRecoilState } from "recoil";
import { projectInfoState } from "../../recoil";

interface ClassContentProps {
  labelList: string[];
  setLabelList: React.Dispatch<React.SetStateAction<string[]>>;
}

export function ClassContent({ labelList, setLabelList }: ClassContentProps) {
  const { id } = useParams();
  const [classList, setClassList] = useState<string[]>([]);
  const [editedLabel, setEditedLabel] = useState<string>("");
  const [projectData, setProjectData] = useRecoilState(projectInfoState);

  const [editClassMode, setEditClassMode] = useState<{
    [key: string]: boolean;
  }>({});

  useEffect(() => {
    setClassList(labelList);
  }, []);

  const handleEditClick = (label: string, index: number) => {
    setEditedLabel(label);
    setEditClassMode((prevState) => ({
      ...prevState,
      [label]: true,
    }));
  };

  const handleCheckClick = async (oldLabel: string, index: number) => {
    if (editedLabel === "") {
      return toast.error("클래스는 빈 값이 될 수 없습니다.");
    }

    const updatedClassList = classList.map((label) => (label === oldLabel ? editedLabel : label));

    const response = await handleChange(index, editedLabel);

    setClassList(updatedClassList);
    setLabelList(updatedClassList);

    setProjectData((prev) =>
      prev
        ? {
            ...prev,
            class: prev.class?.map((c, i) => (i === index ? editedLabel : c)) ?? [],
          }
        : prev,
    );

    toast.success(t(response.message));
    setEditedLabel("");
    setEditClassMode((prevState) => ({
      ...prevState,
      [oldLabel]: false,
    }));
  };

  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditedLabel(e.target.value);
  };

  const handleRemoveClick = async (selectedLabel: string) => {
    if (
      window.confirm("해당 클래스에 포함되어있던 이미지들은 ETC 클래스로 자동 라벨링됩니다. 정말 삭제하시겠습니까?")
    ) {
      try {
        await deleteProjectClass(Number(id), selectedLabel);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleChange = async (index: number, updatedClassItem: string) => {
    try {
      const response = await editProjectClass(Number(id), index, updatedClassItem);
      setLabelList(response.class);
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box sx={{ width: "600px" }}>
      <TableContainer>
        <Table>
          <TableBody>
            {classList.length > 0 &&
              classList.map((listItem, index) => (
                <TableRow key={index}>
                  {/* <TableCell>
                    <MoreVertIcon />
                  </TableCell> */}
                  {editClassMode[listItem] ? (
                    <>
                      <TableCell>
                        <TextField
                          variant="standard"
                          value={editedLabel}
                          sx={{ width: "70px" }}
                          onChange={handleLabelChange}
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleCheckClick(listItem, index)}>
                          <CheckIcon />
                        </IconButton>
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell>{listItem}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleEditClick(listItem, index)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleRemoveClick(listItem)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </>
                  )}
                  <TableCell></TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
